// src/context/PageTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a manual GA4 page_view on every React Router navigation.
// gtag.js is loaded with `send_page_view: false` in public/index.html, so
// this is the single source of page_view events. Consent Mode v2 handles
// whether the event is fully attributed or sent in cookieless/modeled form.
export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    // Meta Pixel PageView — mirrors GA4 above. Held until consent is granted
    // (see fbq('consent','revoke') in public/index.html); the queued views are
    // released by CookieConsentContext on accept.
    if (window.__META_PIXEL_ON && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}
